/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixedprice1Inputs */

const en_fixedprice1 = /** @type {(inputs: Fixedprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed Price`)
};

const de_fixedprice1 = /** @type {(inputs: Fixedprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festpreis`)
};

/**
* | output |
* | --- |
* | "Fixed Price" |
*
* @param {Fixedprice1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const fixedprice1 = /** @type {((inputs?: Fixedprice1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixedprice1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fixedprice1(inputs)
	return de_fixedprice1(inputs)
});
export { fixedprice1 as "fixedPrice" }